export const CREATE_ENTITY_REQUEST = "CREATE_ENTITY_REQUEST";
export const CREATE_ENTITY_SUCCESS = "CREATE_ENTITY_SUCCESS";
export const CREATE_ENTITY_FAIL = "CREATE_ENTITY_FAIL";

export const GET_ALL_ENTITY_LIST_REQUEST = "GET_ALL_ENTITY_LIST_REQUEST";
export const GET_ALL_ENTITY_LIST_SUCCESS = "GET_ALL_ENTITY_LIST_SUCCESS";
export const GET_ALL_ENTITY_LIST_FAIL = "GET_ALL_ENTITY_LIST_FAIL";

export const GET_ALL_ENTITY_REQUEST = "GET_ALL_ENTITY_REQUEST";
export const GET_ALL_ENTITY_SUCCESS = "GET_ALL_ENTITY_SUCCESS";
export const GET_ALL_ENTITY_FAIL = "GET_ALL_ENTITY_LIST_FAIL";

export const GET_SINGLE_ENTITY_DETAILS_REQUEST =
  "GET_SINGLE_ENTITY_DETAILS_REQUEST";
export const GET_SINGLE_ENTITY_DETAILS_SUCCESS =
  "GET_SINGLE_ENTITY_DETAILS_SUCCESS";
export const GET_SINGLE_ENTITY_DETAILS_FAIL = "GET_SINGLE_ENTITY_DETAILS_FAIL";

export const UPDATE_ENTITY_OVERVIEW_REQUEST = "UPDATE_ENTITY_OVERVIEW_REQUEST";
export const UPDATE_ENTITY_OVERVIEW_SUCCESS = "UPDATE_ENTITY_OVERVIEW_SUCCESS";
export const UPDATE_ENTITY_OVERVIEW_FAIL = "UPDATE_ENTITY_OVERVIEW_FAIL";

export const UPDATE_ENTITY_FORMATS_REQUEST = "UPDATE_ENTITY_FORMATS_REQUEST";
export const UPDATE_ENTITY_FORMATS_SUCCESS = "UPDATE_ENTITY_FORMATS_SUCCESS";
export const UPDATE_ENTITY_FORMATS_FAIL = "UPDATE_ENTITY_FORMATS_FAIL";

export const GET_ENTITY_FORMATS_REQUEST = "GET_ENTITY_FORMATS_REQUEST";
export const GET_ENTITY_FORMATS_SUCCESS = "GET_ENTITY_FORMATS_SUCCESS";
export const GET_ENTITY_FORMATS_FAIL = "GET_ENTITY_FORMATS_FAIL";

export const CREATE_ENTITY_FORMATS_REQUEST = "CREATE_ENTITY_FORMATS_REQUEST";
export const CREATE_ENTITY_FORMATS_SUCCESS = "CREATE_ENTITY_FORMATS_SUCCESS";
export const CREATE_ENTITY_FORMATS_FAIL = "CREATE_ENTITY_FORMATS_FAIL";

export const ADD_ENTITY_COMMENTS_REQUEST = "ADD_ENTITY_COMMENTS_REQUEST";
export const ADD_ENTITY_COMMENTS_SUCCESS = "ADD_ENTITY_COMMENTS_SUCCESS";
export const ADD_ENTITY_COMMENTS_FAIL = "ADD_ENTITY_COMMENTS_FAIL";

export const GET_ENTITY_COMMENTS_REQUEST = "GET_ENTITY_COMMENTS_REQUEST";
export const GET_ENTITY_COMMENTS_SUCCESS = "GET_ENTITY_COMMENTS_SUCCESS";
export const GET_ENTITY_COMMENTS_FAIL = "GET_ENTITY_COMMENTS_FAIL";

export const GET_ENTITY_ACTIVITY_LOGS_REQUEST =
  "GET_ENTITY_ACTIVITY_LOGS_REQUEST";
export const GET_ENTITY_ACTIVITY_LOGS_SUCCESS =
  "GET_ENTITY_ACTIVITY_LOGS_SUCCESS";
export const GET_ENTITY_ACTIVITY_LOGS_FAIL = "GET_ENTITY_ACTIVITY_LOGS_FAIL";
